import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const ParentWithChildrenIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2220_9836)">
          <path
            d="M5.69509 5.89329C5.76866 5.30626 6.32507 4.90047 6.90688 5.00774C11.8245 5.91445 20.4537 7.04437 25.8506 14.2839C31.4053 21.7349 29.5285 27.7741 28.1827 33.811C28.0731 34.3028 27.6198 34.6411 27.1171 34.6064C21.6804 34.231 14.5845 34.1952 9.06785 26.7953C3.62213 19.4904 5.00357 11.4107 5.69509 5.89329Z"
            fill="#E5FAF0"
          />
          <path
            d="M13.3333 35V31.6667C13.3333 29.8986 14.0357 28.2029 15.286 26.9526C16.5362 25.7024 18.2319 25 20 25H26.6667C28.4348 25 30.1305 25.7024 31.3807 26.9526C32.631 28.2029 33.3333 29.8986 33.3333 31.6667V35"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66666 36.4167V33.0833C6.67512 31.6119 7.17013 30.1847 8.07454 29.024C8.97896 27.8633 10.2419 27.0345 11.6667 26.6667"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M23.3332 18.3333C27.0151 18.3333 29.9998 15.3486 29.9998 11.6667C29.9998 7.98477 27.0151 5 23.3332 5C19.6513 5 16.6665 7.98477 16.6665 11.6667C16.6665 15.3486 19.6513 18.3333 23.3332 18.3333Z"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3213 12C12.0853 12.3165 10.9898 13.0353 10.2074 14.0432C9.4251 15.0511 9.00046 16.2906 9.00046 17.5665C9.00046 18.8424 9.4251 20.082 10.2074 21.0899C10.9898 22.0977 12.0853 22.8166 13.3213 23.133"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <clipPath id="clip0_2220_9836">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
